import { render } from "./TableHeadCell.vue?vue&type=template&id=3be116fa&scoped=true&ts=true"
import script from "./TableHeadCell.vue?vue&type=script&lang=tsx"
export * from "./TableHeadCell.vue?vue&type=script&lang=tsx"

import "./TableHeadCell.vue?vue&type=style&index=0&id=3be116fa&lang=scss&scoped=true"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be116fa"]])

export default __exports__